import { AssortmentView } from '@retail/my-assortment/types';
import { OrgUnitType } from '@retail/mgpris/config-types';
import { AssortmentExportColumn } from './AssortmentExportColumn';

type ExportAssortmentColumnConfig = Record<
  AssortmentExportColumn,
  {
    views: AssortmentView[];
    orgUnits: OrgUnitType[];
  }
>;

export const assortmentViewExportColumns: ExportAssortmentColumnConfig = {
  supplierItemPrimaryText: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  mgItemNumber: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  finfoNumber: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  nobbNumber: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  primaryGtin: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  supplierName: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  productGroupNumber: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  discountGroupName: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  purchaseConditionName: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  purchaseConditionLevel: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  purchasePrice: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES'],
  },
  purchasePriceUnit: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES'],
  },
  purchasePriceDate: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES'],
  },
  futurePurchasePrice: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES'],
  },
  futurePurchasePriceUnit: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES'],
  },
  futurePurchasePriceDate: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES'],
  },
  purchasePriceChangeAbsolute: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES'],
  },
  purchasePriceChangePercentage: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES'],
  },
  freightValue: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  freightValueDenomination: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  freightUnit: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  costPrice: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  costPriceUnit: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  costPriceDate: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  costPriceInBasePriceUnit: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  costPriceBasePriceUnit: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  MGLSalesPrice: { orgUnits: [OrgUnitType.WHOLESALE_PRICE_LIST], views: ['ASSORTMENT_FULL'] },
  MGLDG: { orgUnits: [OrgUnitType.WHOLESALE_PRICE_LIST], views: ['ASSORTMENT_FULL'] },
  customerFactor: { orgUnits: [OrgUnitType.WHOLESALE_PRICE_LIST], views: ['ASSORTMENT_FULL'] },
  salesPriceExVat: {
    orgUnits: [
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
      OrgUnitType.WHOLESALE_PRICE_LIST,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  salesPriceIncVat: {
    orgUnits: [
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
      OrgUnitType.WHOLESALE_PRICE_LIST,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },

  vatRate: {
    orgUnits: [OrgUnitType.RETAIL_LOCATION, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  salesPriceUnit: {
    orgUnits: [OrgUnitType.RETAIL_LOCATION, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  salesPriceDate: {
    orgUnits: [OrgUnitType.RETAIL_LOCATION, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  salesPriceCoverage: {
    orgUnits: [OrgUnitType.RETAIL_LOCATION, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
  salesPriceDpakExVat: {
    orgUnits: [OrgUnitType.WHOLESALE_PRICE_LIST, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  salesPriceDpakIncVat: {
    orgUnits: [OrgUnitType.WHOLESALE_PRICE_LIST, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  salesPriceDpakCoverage: {
    orgUnits: [OrgUnitType.WHOLESALE_PRICE_LIST, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  salesPriceTpakExVat: {
    orgUnits: [OrgUnitType.WHOLESALE_PRICE_LIST, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  salesPriceTpakIncVat: {
    orgUnits: [OrgUnitType.WHOLESALE_PRICE_LIST, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  salesPriceTpakCoverage: {
    orgUnits: [OrgUnitType.WHOLESALE_PRICE_LIST, OrgUnitType.WHOLESALE_LOCATION],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  futureSalesPriceExVat: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'PRICE_CHANGES'],
  },
  futureSalesPriceIncVat: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'PRICE_CHANGES'],
  },
  futureSalesPriceUnit: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'PRICE_CHANGES'],
  },
  futureSalesPriceDate: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'PRICE_CHANGES'],
  },
  futureSalesPriceCoverage: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'PRICE_CHANGES'],
  },
  salesPriceIncVatChangeAbsolute: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'PRICE_CHANGES'],
  },
  salesPriceExVatChangeAbsolute: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'PRICE_CHANGES'],
  },
  salesPriceChangePercantage: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'PRICE_CHANGES'],
  },
  priceConditionOrigin: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  priceSuggestionType: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  priceConditionLevel: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  assortmentDate: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  expiresFromAssortmentDate: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  assortmentSource: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE'],
  },
  finfoExpiresDate: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  finfoExpiresStatus: {
    orgUnits: [
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
    ],
    views: ['ASSORTMENT_FULL'],
  },
  addedBy: {
    orgUnits: [OrgUnitType.RETAIL_BRAND],
    views: ['ASSORTMENT_FULL', 'ASSORTMENT_SIMPLE', 'PRICE_CHANGES', 'COMPETITOR_PRICES'],
  },
};
